<template>
  <b-modal
    body-class="padding"
    button-size="sm"
    size="md"
    title="Create a branch"
    title-tag="h5"
    cancel-title="Cancel"
    id="idNewBranchModal"
    cancel-variant="outline-primary"
    :ok-disabled="branchName === null"
    :ok-title="branch ? 'Update' : 'Create'"
    @shown="focusFirstInput"
    @show="onShow"
    @hidden="clearData"
    @ok="onOk"
  >
    <div class="padding">
      <b-row>
        <label class="required" for="idBranchName">Branch Name</label>
        <b-form-input
          size="sm"
          id="idBranchName"
          ref="firstInput"
          trim
          v-model="branchName"
        ></b-form-input>
      </b-row>
    </div>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      branchName: null,
    };
  },
  props: ["branch"],
  created() {},
  methods: {
    focusFirstInput() {
      this.$refs.firstInput.focus();
    },
    onShow() {
      if (this.branch) {
        this.branchName = this.branch.branchName;
      }
    },
    onOk() {
      if (this.branch) {
        this.$emit("updateBranch", {
          branchName: this.branchName,
          id: this.branch.id,
        });
      } else {
        this.$emit("newBranch", {
          branchName: this.branchName,
        });
      }
    },
    clearData() {
      this.branchName = null;
    },
  },
};
</script>

<style scoped>
.padding {
  padding: 1rem 3rem;
}
.row {
  margin: 0.8rem 0;
}
</style>